import React from 'react';

type FormControlErrorProps = {
  error: string;
};

export const FormControlError = ({ error }: FormControlErrorProps) => {
  return (
    <div data-testid='form-control-error' className='d-flex align-items-center invalid-feedback'>
      <div>
        <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <g clipPath='url(#clip0)'>
            <circle cx='8' cy='8' r='8' fill='#010101' />
            <path
              d='M8.68988 3.31381C9.10337 3.73223 9.10337 4.41062 8.68988 4.82904L6.54446 7H12C12.5523 7 13 7.44772 13 8C13 8.55229 12.5523 9 12 9H6.54446L8.68988 11.171C9.10337 11.5894 9.10337 12.2678 8.68988 12.6862C8.27638 13.1046 7.60597 13.1046 7.19247 12.6862L3.31012 8.75761C2.89663 8.3392 2.89663 7.6608 3.31012 7.24239L7.19247 3.31381C7.60597 2.8954 8.27638 2.8954 8.68988 3.31381Z'
              fill='white'
            />
          </g>
          <defs>
            <clipPath id='clip0'>
              <path d='M0 0.00170898H16V16.0017H0V0.00170898Z' fill='white' />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className='p-2' data-testid='form-control-error-message'>
        {error}
      </div>
    </div>
  );
};
